import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Blletiket } from './../../../providers/bll/bll-etiket';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';



@Component({
  selector: 'page-etiketlistesi',
  templateUrl: 'etiketlistesi.html',
})
export class EtiketlistesiPage {
  etiketListesi: any = [];
  onaylaPasif: boolean = false;
  yaziciadi: any;

  constructor(public navCtrl: NavController,
    public viewCtrl: ViewController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public navParams: NavParams) {
    this.yaziciadi = this.ortak.StAyarGetir.BarkodYaziciAdi;
  }

  ionViewDidLoad() {

    this.EtiketDetayListesi_Temp();

  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  EtiketDetayListesi_Temp() {
    var blletiket = new Blletiket();
    blletiket.getAll().then(a => {
      var sonuc = <any>a;
      this.etiketListesi = sonuc;

      if (sonuc == length > 0) {
        this.onaylaPasif = true;
      }
    })

  }
  cacheTemizle() {

    var blletiket = new Blletiket();
    blletiket.execRawQuery("DELETE FROM Rafetiket ").then(b => {
      this.EtiketDetayListesi_Temp();
      //this.onaylaPasif = true;
    }).catch(x => {
      console.log(x);
    })
  }
  etiketSil(etikets) {

    var blletiket = new Blletiket();
    blletiket.delete({ StokKartiID: etikets.StokKartiID }).then(a => {
      this.EtiketDetayListesi_Temp();
    }).catch(x => {
      console.log(x);
    })

  }

  kaydet() {
    var blletiket = new Blletiket();
    blletiket.getAll().then(a => {
      var formData = new FormData();
      formData.append("asd", JSON.stringify(a));
      formData.append("yaziciadi", this.yaziciadi);
      this.bllOrtak.islem(formData, "TopluRafEtiketGonder", "", false).then(a => {
        var sonuc=<any>a;
        console.log("sonuc",sonuc)
      }).catch(x=>
        {
          this.ortak.showBasicAlert("Başarılı","Etiketler Basıldı");
        })
     
      this.viewCtrl.dismiss();
    });
    this.cacheTemizle();
  }

}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/etiketlistesi/etiketlistesi.ts